import type { FeatureOption } from './FeatureSelector'

import { Stack, Typography } from '@mui/material'

import { FeatureCard } from './FeatureCard'

export interface FeatureCardListProps {
  features: FeatureOption[]
  selectedFeatureId?: string
  creatingSet?: boolean
  onCardClick: (feature: FeatureOption) => void
  variant?: 'horizontal' | 'vertical'
}

export function FeatureCardList({
  features,
  selectedFeatureId,
  creatingSet = false,
  onCardClick,
  variant = 'horizontal',
}: FeatureCardListProps) {
  const isHorizontal = variant === 'horizontal'

  return (
    <Stack gap="12px">
      <Typography fontSize={18} fontWeight={600} lineHeight="28px">
        Popular Features
      </Typography>
      <Stack
        direction={isHorizontal ? 'row' : 'column'}
        display="flex"
        flexWrap={isHorizontal ? 'wrap' : 'nowrap'}
        gap="12px"
      >
        {features.map(feature => (
          <FeatureCard
            key={feature.id}
            creatingSet={creatingSet}
            feature={feature}
            selectedFeatureId={selectedFeatureId}
            tag={feature.tag}
            onClick={onCardClick}
          />
        ))}
      </Stack>
    </Stack>
  )
}
